var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairsPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37.5V19.95C19.5 19.4328 19.658 18.9368 19.9393 18.5711C20.2206 18.2054 20.6022 18 21 18H28.5V37.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37.5V19.95C19.5 19.4328 19.658 18.9368 19.9393 18.5711C20.2206 18.2054 20.6022 18 21 18H28.5V37.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.2143V12.4286C28.5 11.9171 28.658 11.4265 28.9393 11.0649C29.2206 10.7032 29.6022 10.5 30 10.5H36C36.3978 10.5 36.7794 10.7032 37.0607 11.0649C37.342 11.4265 37.5 11.9171 37.5 12.4286V35.5714C37.5 36.0829 37.342 36.5735 37.0607 36.9351C36.7794 37.2968 36.3978 37.5 36 37.5H12C11.6022 37.5 11.2206 37.2968 10.9393 36.9351C10.658 36.5735 10.5 36.0829 10.5 35.5714V27.8571C10.5 27.3457 10.658 26.8551 10.9393 26.4934C11.2206 26.1318 11.6022 25.9286 12 25.9286H19.5",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.2143V12.4286C28.5 11.9171 28.658 11.4265 28.9393 11.0649C29.2206 10.7032 29.6022 10.5 30 10.5H36C36.3978 10.5 36.7794 10.7032 37.0607 11.0649C37.342 11.4265 37.5 11.9171 37.5 12.4286V35.5714C37.5 36.0829 37.342 36.5735 37.0607 36.9351C36.7794 37.2968 36.3978 37.5 36 37.5H12C11.6022 37.5 11.2206 37.2968 10.9393 36.9351C10.658 36.5735 10.5 36.0829 10.5 35.5714V27.8571C10.5 27.3457 10.658 26.8551 10.9393 26.4934C11.2206 26.1318 11.6022 25.9286 12 25.9286H19.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsPoi);
export default __webpack_public_path__ + "static/media/stairs-poi.19d933613feab9a5879498d070de110d.svg";
export { ForwardRef as ReactComponent };